package org.chiangmeng.qfast.core.di

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.database.database
import dev.gitlive.firebase.auth.auth
import org.chiangmeng.qfast.core.data.di.dataModule
import org.chiangmeng.qfast.core.data.di.localDataModule
import org.chiangmeng.qfast.core.domain.di.domainModule
import org.chiangmeng.qfast.core.domain.usecases.QueueStatusUseCase
import org.chiangmeng.qfast.core.presentation.di.uiModule
import org.koin.dsl.module

val appModule = module {
    includes(uiModule, dataModule, domainModule, localDataModule)
    single {
        val db = Firebase.database("https://qfast-df5e6-default-rtdb.asia-southeast1.firebasedatabase.app")
        db.setLoggingEnabled(false)
        db
    }
    single { Firebase.auth }
    single<org.chiangmeng.qfast.core.domain.ports.AuthRepository> { 
        org.chiangmeng.qfast.core.data.remote.FirebaseAuthRepositoryImpl(get()) 
    }
    factory { org.chiangmeng.qfast.features.auth.AuthViewModel(get(), get()) }

    single { QueueStatusUseCase() }
}
